/* Publish by EComposer at 2025-07-31 21:11:05*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-s41y3cb17qo"]=  window.__ectimmers["ecom-s41y3cb17qo"] || {};
if(!this.$el)return;let e=this.$el;this.isLive;var i=this.id;const t=function(){const s=document.querySelectorAll(".ecom-container-lightbox-"+i);s.length&&s.forEach(function(o){const a=o.querySelector("iframe");a!=null&&(a.contentWindow.postMessage('{"method":"pause"}',"*"),a.src="");const r=o.querySelector("video");r!=null&&r.pause()})};if(e&&window.EComModal){var n=e.querySelector("[ecom-modal]");new window.EComModal(n,{cssClass:["ecom-container-lightbox-"+this.id,"ecom-html","ecom-modal","ecommodal-slide"],onOpen:function(){const s=document.querySelectorAll(".ecom-container-lightbox-"+i);s.length&&(s.forEach(function(o){const a=o.querySelector("iframe");if(a!=null){const c=a.src.replace("muted=1","muted=0").replace("mute=1","mute=0");a.src=c}const r=o.querySelector("video");r!=null&&r.play()}),window.dispatchEvent(new CustomEvent("ecom-lightbox-opened",{detail:{id:i,el:s}})))},onClose:t})}t()

                    });
                    
                        document.querySelectorAll('.ecom-s41y3cb17qo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s41y3cb17qo', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}